module.exports = __webpack_public_path__ + "static/health-tracker-app-cover-ad326708ddaf74f3e22dc9d981783309.png";